import { PROVIDERS_MAP } from 'common/constants/constants';
import useProviderMetaData from './useProviderMetaData';
import _ from 'lodash';

const PROVIDER_HOOKS = {
  [PROVIDERS_MAP.jira.name]: useProviderMetaData,
  [PROVIDERS_MAP.azure_boards.name]: useProviderMetaData
};

export const getProviderHook = sensorName =>
  _.get(PROVIDER_HOOKS, sensorName, null);
